import React, { useState, useEffect } from "react";
import TypeApi from "../../api/TypeApi";
import { showError, showSuccess } from "../../utils/toastUtils";

function EditDetails({ typeData, fetchTypes, clearSelection }) {
  const [type, setType] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (typeData) setType(typeData.type || "");
  }, [typeData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!type.trim()) {
      setErrors({ type: "Type is required" });
      return;
    }

    try {
      const payload = {
        id: typeData._id,
        type, 
      };

      const res = await TypeApi.update(payload);

      if (res.code === 200) {
        showSuccess(res.message);
        document.getElementById("closeOffcanvasBtnEdit").click();

        if (fetchTypes) fetchTypes();
        if (clearSelection) clearSelection();
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Edit Type</h4>
          <button type="button" className="btn-close" data-bs-dismiss="modal" id="closeOffcanvasBtnEdit" />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body container">
            <div className="mb-3">
              <label className="form-label">Type</label>
              <input
                type="text"
                className="form-control"
                value={type}
                onChange={(e) => setType(e.target.value)}
              />
              {errors.type && (
                <span className="text text-danger">{errors.type}</span>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={clearSelection}
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditDetails;
